// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import router from './router';
import http from './http';
import App from './App';
import ElementUI from 'element-ui';
import Video from 'video.js';
import 'video.js/dist/video-js.css';
import 'element-ui/lib/theme-chalk/index.css';
import 'babel-polyfill';
import './assets/iconfont/iconfont.css';
import './common/common.scss';
import './common/public.scss';
import infiniteScroll from 'vue-infinite-scroll';

Vue.prototype.$http = http;
Vue.config.productionTip = false;
Vue.use(infiniteScroll);
Vue.use(ElementUI);
Vue.prototype.$video = Video;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js